export enum FeatureFlagId {
	PRESERVE_QUERY_PARAMS = 'adminPortalPreserveQueryParams'
}

export const QUERY_FF_PREFIX = 'feature';

export interface IReqFeatureFlags {
	features: {
		flag: string;
		defaultVal: boolean;
	}[];
}

export interface IResFeatureFlags {
	features: Record<string, boolean | null | undefined>;
}

export interface IServerFeatureFlags {
	features: Record<FeatureFlagId, boolean | null | undefined>;
}
